module.exports = __webpack_public_path__ + "static/media/banner2.2415200f.jpg";